import { render, staticRenderFns } from "./GlobalFeed.vue?vue&type=template&id=5b46aa43&"
import script from "./GlobalFeed.vue?vue&type=script&lang=js&"
export * from "./GlobalFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports